import { Component, Fragment } from 'react';
import { postData, putData, getData } from "../../servicos/api";
import { isAdmin } from "../../servicos/auth";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form, FormGroup, Label, Input, Button, Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import Navbar from '../../Components/Navbar';
import Sidebar from '../../Components/Sidebar';
import ModalResponse from '../../Components/ModalResponse';
import Combobox from '../../Components/Combobox';
import { Link } from "react-router-dom";
import Switch from 'react-switch';

//REDUX
import { setLoaderShow, setResponseModal } from '../../reducers/index';
import { connect } from 'react-redux';

const Formulario = (props) => {
    let estabelecimento;
    if (props.data && props.data.estabelecimento_id !== undefined && props.data.estabelecimento_id !== null && props.listaEstabelecimentos.length > 0) {
        estabelecimento = props.listaEstabelecimentos.filter(function (elem, i, object) {
            return elem.value === props.data.estabelecimento_id;
        });
        if(estabelecimento[0] !== undefined){
            estabelecimento = { value: estabelecimento[0].value, label: estabelecimento[0].label };
        }
    }

    let estado;
    if (props.data && props.data.estado_id !== undefined && props.data.estado_id !== null && props.listaEstados.length > 0) {
        estado = props.listaEstados.filter(function (elem, i, object) {
            return elem.value === props.data.estado_id;
        });
        if(estado[0] !== undefined){
            estado = { value: estado[0].value, label: estado[0].label };
        }
    }

    let validarAdmin = Yup.object({
        nome: Yup.string()
            .min(2, 'O campo nome deverá ter no mínimo 2 caracteres.')
            .max(90, 'O campo nome deverá ter no máximo 90 caracteres.')
            .required('O campo nome é obrigatório.')
            .trim(),
        estado_id: Yup.object()
            .required('O campo estado é obrigatório.'),
        estabelecimento_id: Yup.object()
            .required('O campo estabelecimento é obrigatório.'),
    });

    let validarEstabelecimento = Yup.object({
        nome: Yup.string()
            .min(2, 'O campo nome deverá ter no mínimo 2 caracteres.')
            .max(90, 'O campo nome deverá ter no máximo 90 caracteres.')
            .required('O campo nome é obrigatório.')
            .trim(),
        estado_id: Yup.object()
            .required('O campo estado é obrigatório.'),
    });

    const formik = useFormik({
        initialValues: {
            nome:      props.data !== undefined && props.data !== null ? props.data.nome : '',
            ativo:     props.data !== undefined && props.data !== null ? !!parseInt(props.data.ativo) : true,
            estado_id: estado,
            estabelecimento_id: estabelecimento,
        },
        enableReinitialize: true,
        validationSchema: isAdmin() ? validarAdmin : validarEstabelecimento,
        onSubmit: values => {
            let data = {
                "nome" : values.nome,
                "estado_id": values.estado_id.value,
                "ativo": values.ativo,
                "estabelecimento_id": values.estabelecimento_id || (isAdmin()) ? values.estabelecimento_id.value : null,
            }

            if (props.operation !== undefined && props.operation !== null && props.operation === 'alt') {
                props.updateCidade(data, props.data.uuid);
            } else {
                props.insertCidade(data);
            }
        },
    });
    return ( 
        <Form className="forms-sample col-12" onSubmit={formik.handleSubmit}>
            <Card>
                <CardHeader className="bg-maskats text-center">
                    <h4 className="headerTitle">Cadastro de cidades</h4>
                </CardHeader>
                <CardBody>
                    <div>

                        {
                            isAdmin() ? 
                                <FormGroup>
                                    <Label for="estabelecimento_id">* Estabelecimento</Label>
                                    <Combobox
                                        invalid={formik.touched.estabelecimento_id && formik.errors.estabelecimento_id}
                                        valid={formik.touched.estabelecimento_id && !formik.errors.estabelecimento_id}
                                        id="estabelecimento_id"
                                        name="estabelecimento_id"
                                        placeholder={'Selecione um item'}
                                        defaultValue={formik.values.estabelecimento_id}
                                        value={formik.values.estabelecimento_id}
                                        options={props.listaEstabelecimentos}
                                        isMulti={false}
                                        loadingMessage={"Carregando..."}
                                        noOptionsMessage={"Não existem dados cadastrados."}
                                        onChange={formik.setFieldValue}
                                        onBlur={formik.setFieldTouched}
                                        maxMenuHeight={190}
                                    />
                                    {formik.touched.estabelecimento_id && formik.errors.estabelecimento_id ? (
                                        <div className="divError">{formik.errors.estabelecimento_id}</div>
                                    ) : null}
                                </FormGroup>
                            : ""
                        }

                        <FormGroup>
                            <Label for="estado_id">* Estado</Label>
                            <Combobox
                                invalid={formik.touched.estado_id && formik.errors.estado_id}
                                valid={formik.touched.estado_id && !formik.errors.estado_id}
                                id="estado_id"
                                name="estado_id"
                                placeholder={'Selecione um item'}
                                defaultValue={formik.values.estado_id}
                                value={formik.values.estado_id}
                                options={props.listaEstados}
                                isMulti={false}
                                loadingMessage={"Carregando..."}
                                noOptionsMessage={"Não existem dados cadastrados."}
                                onChange={formik.setFieldValue}
                                onBlur={formik.setFieldTouched}
                                maxMenuHeight={190}
                            />
                            {formik.touched.estado_id && formik.errors.estado_id ? (
                                <div className="divError">{formik.errors.estado_id}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="nome">* Nome</Label>
                            <Input 
                                className="form-control form-control-sm" 
                                id="nome" 
                                name="nome" 
                                type="text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.nome}
                                minLength={2}
                                maxLength={90}
                            />
                            {formik.touched.nome && formik.errors.nome ? (
                                <div className="divError">{formik.errors.nome}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup className="mb-0">
                            <Label for="ativo">Ativo</Label>
                            <br />
                            <Switch
                                id="ativo"
                                name="ativo"
                                onColor="#28a745"
                                offColor="#dc3545"
                                checked={formik.values.ativo}
                                onChange={()=>formik.setFieldValue('ativo', !formik.values.ativo)}
                            />
                        </FormGroup>
                    </div>
                </CardBody>
                <CardFooter className="text-align-end bg-white">
                    <Link replace to="/cidade">
                        <Button className="mr-2 text-white btn btn-sm btn-secondary btn-fw bd-rd-8" type="button">
                            <i className="fa fa-arrow-left btn-icon-append btn-fs-def"></i>
                            <span className="label-button btn-fs-def">Cancelar</span>
                        </Button>
                    </Link>

                    <Button className="btn btn-sm btn-success btn-fw bd-rd-8" type="submit">
                        <i className="fa fa-check btn-icon-append btn-fs-def"></i>
                        <span className="label-button btn-fs-def">Salvar</span>
                    </Button>
                </CardFooter>
            </Card>
        </Form>
    );
}

class CidadeFormulario extends Component {
    constructor(props){
        super(props);

        this.state = {
            listaEstabelecimentos: [],
            listaEstados: [],
        };
        
        this.loadingShow  = this.loadingShow.bind(this);
        this.updateCidade = this.updateCidade.bind(this);
        this.insertCidade = this.insertCidade.bind(this);
    }

    async componentDidMount(){
        this.loadingShow(true);
        
        let [listaEstabelecimentos, listaEstados] = await Promise.all([
            getData(`/estabelecimento`, this.props),
            getData(`/estado`, this.props)
        ]);

        if(listaEstabelecimentos !== null){
            listaEstabelecimentos = listaEstabelecimentos.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }

        if(listaEstados !== null){
            listaEstados = listaEstados.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }

        this.setState({listaEstados, listaEstabelecimentos});

        this.loadingShow(false);
    }

    loadingShow(value) {
        let { setLoaderShow } = this.props;
        setLoaderShow(value);
    }

    async updateCidade(data, uuid){
        this.loadingShow(true);
        await putData(`/cidade/${uuid}`, this.props, data, '../cidade');
        this.loadingShow(false);
    }

    async insertCidade(data){
        this.loadingShow(true);
        await postData(`/cidade`, this.props, data, '../cidade');
        this.loadingShow(false);
    }

    render(){
        const { data, operation } = this.props.location;
        const { setResponseModal, enableResponseModal } = this.props;
        return (
            <Fragment>
                <div className="container-scroller">
                    <Navbar/>
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar/>
                        <div className="main-panel">
                            <div className="content-wrapper">
                                <div className="row">
                                    <div className="col-md-12 grid-margin stretch-card">
                                        <Formulario
                                            data={data}
                                            operation={operation}
                                            updateCidade={this.updateCidade}
                                            insertCidade={this.insertCidade}
                                            listaEstados={this.state.listaEstados}
                                            listaEstabelecimentos={this.state.listaEstabelecimentos}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalResponse 
                    history={this.props.history} 
                    setResponseModal={setResponseModal} 
                    enableResponseModal={enableResponseModal}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        enableLoaderShow: state.enableLoaderShow,
        enableResponseModal: state.enableResponseModal,
    }
};

const mapDispatchToProps = dispatch => ({
    setLoaderShow: enable => dispatch(setLoaderShow(enable)),
    setResponseModal: enable => dispatch(setResponseModal(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CidadeFormulario);